export default function ProductTable({ products = [], renderProduct }) {
  if (!products.length) return <p className="admin-empty-state">No products yet. New products are always created as drafts.</p>;
  return <div className="admin-record-list">{products.map((product) => <div key={product._id}>{renderProduct(product)}</div>)}</div>;
}
